export default "/images/vendor/flag-icon-css/flags/1x1/ad.svg?94e810253dbc84702e9a1b1f44e3de36";